<template>
    <input class="form-control" :autocomplete="autocomplete" :class="{ invalid: error }" type="text" ref="input"
        :name="id" :id="id" :maxlength="maxlength" :minlength="minlength" v-model="model" @input="update"
        @blur="onBlur" />
</template>

<script>
export default {
    name: 'FormField',
    props: {
        id: String,
        value: String | Number,
        error: {
            type: Boolean,
            default: false
        },
        maxlength: {
            type: String,
            default: '150'
        },
        minlength: {
            type: String,
            default: '0'
        },
        type: {
            type: String,
            default: null
        },
        autocomplete: {
            type: String,
            default: 'on'
        }
    },
    data() {
        return {
            model: this.value
        };
    },
    watch: {
        value(newValue) {
            this.model = this.formatValue(newValue);
        }
    },
    methods: {
        update() {
            this.model = this.formatValue(this.model);
            this.$emit('input', this.formatValue(this.model));
            this.$emit('change', this.formatValue(this.model));
        },
        onBlur() {
            // trim whitespace
            if (this.model) {
                this.model = `${this.model}`.trim();
            }
            this.update();
            this.$emit('blur');
        },
        formatValue(value) {
            if (!value) return '';

            if (this.type == 'number') {
                return `${value}`.replace(/\D+/g, '');
            }

            if (this.type == 'number-non-zero') {
                // numbers only no leading zero
                if (`${value}`.length == 1) {
                    return `${value}`.replace(/\D+/g, '');
                }

                return `${value}`.replace(/\D+/g, '').replace(/^0+/, '');
            }

            if (this.type == 'decimal') {
                return `${(`${value}`.replace(/[^.0-9]/g, ''))}`;
            }

            if (this.type == 'one-decimal') {
                return formatNumberWithOneDecimal(value);
            }

            if (this.type == 'nospace') {
                return `${value}`.replace(/\s/g, '');
            }

            if (this.type == 'lowercase') {
                return `${value}`.toLowerCase();
            }

            if (this.type == 'alpha-numeric') {
                return `${value}`.replace(/[^a-zA-Z0-9]/g, '');
            }

            if (this.type == 'alpha-space') {
                return `${value}`.replace(/[^a-zA-Z ]/g, '');
            }


            return value;
        }
    }
};

function formatNumberWithOneDecimal(value) {
    // Remove all non-digit characters except the first decimal point
    let valueDigits = `${value}`.replace(/[^\d.]/g, '');

    // Ensure only one decimal point
    let parts = valueDigits.split('.');
    if (parts.length > 2) {
        parts = [parts[0], parts.slice(1).join('')];
    }

    // Limit to one decimal place
    if (parts[1] && parts[1].length > 1) {
        parts[1] = parts[1].slice(0, 1);
    }

    // Reconstruct the number
    value = parts.join('.');

    // Update the input value
    return value;
}
</script>
